export default class ObservePosition {
	static DEBOUNCE_TIME = 200; // リサイズのデバウンスタイム
	static EVENT_NAME = 'classChanged'; // カスタムイベント名

	constructor(target, positionClasses, options = {}) { // target: 監視対象の要素, positionClasses: クラス名のオブジェクト, options: オプション
		this.target = target; // 監視対象の要素
		this.positionClasses = positionClasses; // クラス名のオブジェクト
		this.selector = options.selector || '[data-observe]'; // 監視対象のセレクタ
		this.fireCustomEvent = options.fireCustomEvent || false; // カスタムイベントを発火するかどうか
		this.bodyBorderTop = this.getBodyBorderTop(); // bodyのborder-topの値
		if (positionClasses) {
			this.initTarget(); // 監視対象の初期化
		}

		this.observeBody(); // bodyの監視
	}

	// bodyの監視
	observeBody() {
		const observer = new MutationObserver(() => {
			this.targets = document.querySelectorAll(this.selector); // 監視対象の要素を取得
		});
		observer.observe(document.body, { childList: true, subtree: true }); // bodyの変更を監視
	}

	// bodyのborder-topの値を取得
	getBodyBorderTop() {
		const body = document.body;
		const style = window.getComputedStyle(body); // bodyのスタイルを取得
		const borderTopWidth = parseFloat(style.borderTopWidth); // border-topの値を取得
		return isNaN(borderTopWidth) ? 0 : borderTopWidth; // border-topの値がNaNの場合は0を返す
	}

	// 監視対象の初期化
	initTarget() {
		const checkPosition = () => {
			this.checkPosition(); // 監視対象の位置をチェック
			this.frameRequest = requestAnimationFrame(checkPosition); // リクエストアニメーションフレームを設定
		};
		checkPosition(); // 監視対象の位置をチェック

		let resizeTimeout; // リサイズのタイムアウト
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimeout); // リサイズのタイムアウトをクリア
			resizeTimeout = setTimeout(() => {
				if (this.frameRequest) { // リクエストアニメーションフレームがある場合
					cancelAnimationFrame(this.frameRequest); // リクエストアニメーションフレームをキャンセル
				}
				checkPosition(); // 監視対象の位置をチェック
			}, ObservePosition.DEBOUNCE_TIME); // リサイズのデバウンスタイム
		});
	}

	// 監視対象の位置をチェック
	checkPosition() {
		const { offsetHeight: targetH, offsetTop: targetT } = this.target; // 監視対象の高さと位置を取得
		const targetTop = targetT + this.bodyBorderTop; // 監視対象の上端の位置を取得
		let classToAdd = null; // 追加するクラス

		const scrollY = window.scrollY; // スクロール位置を取得
		const innerHeight = window.innerHeight; // ウィンドウの高さを取得

		if (scrollY > targetTop + targetH) { // スクロール位置が監視対象の下端よりも下にある場合
			classToAdd = this.updateClasses(['topOn', 'topDown'], 'topUp');
		} else if (scrollY > targetTop) { // スクロール位置が監視対象の上端よりも下にある場合
			classToAdd = this.updateClasses(['topUp', 'topDown'], 'topOn');
		} else {
			classToAdd = this.updateClasses(['topUp', 'topOn'], 'topDown');
		}

		if (scrollY + innerHeight < targetTop) { // スクロール位置が監視対象の上端よりも上にある場合
			classToAdd = this.updateClasses(['bottomUp', 'bottomOn'], 'bottomDown');
		} else if (scrollY + innerHeight < targetTop + targetH) { // スクロール位置が監視対象の下端よりも上にある場合
			classToAdd = this.updateClasses(['bottomUp', 'bottomDown'], 'bottomOn');
		} else {
			classToAdd = this.updateClasses(['bottomDown', 'bottomOn'], 'bottomUp');
		}

		if (classToAdd && this.fireCustomEvent) { // クラスが追加された場合かつカスタムイベントを発火する場合
			const event = new CustomEvent(ObservePosition.EVENT_NAME, { detail: { addedClass: classToAdd, target: this.target } }); // カスタムイベントを作成
			document.dispatchEvent(event); // カスタムイベントを発火
		}
	}

	// クラスの更新
	updateClasses(removeClasses, addClass) {
		const classesToRemove = removeClasses.map(className => this.positionClasses[className]).filter(Boolean); // 削除するクラス
		const classToAdd = this.positionClasses[addClass]; // 追加するクラス
		let changed = false; // 変更されたかどうか
		let actualRemovedClasses = []; // 実際に削除されたクラス

		classesToRemove.forEach(className => { // 削除するクラスをループ
			if (this.target.classList.contains(className)) { // クラスが存在する場合
				this.target.classList.remove(className); // クラスを削除
				actualRemovedClasses.push(className); // 実際に削除されたクラスに追加
				changed = true;
			}
		});

		if (classToAdd && !this.target.classList.contains(classToAdd)) { // 追加するクラスが存在し、クラスが存在しない場合
			this.target.classList.add(classToAdd); // クラスを追加
			changed = true;
		}

		if (changed) {
			const event = new CustomEvent(ObservePosition.EVENT_NAME, { detail: { addedClass: classToAdd, removedClasses: actualRemovedClasses, target: this.target } }); // カスタムイベントを作成
			document.dispatchEvent(event); // カスタムイベントを発火
			return classToAdd; // 追加するクラスを返す
		}
		return null;
	}
}